import { type Stop } from 'core/domain/Stop'
import { isPast } from 'core/utils/date'

import { type QuoteAccessorial } from './QuoteAccessorial'
import { type QuoteEquipmentType } from './QuoteEquipmentType'
import { type QuoteItem } from './QuoteItem'
import { type QuoteMode } from './QuoteMode'
import { type QuoteStop } from './QuoteStop'

export type Quote = {
  bidsDeadline: Date
  canReceiveProposals: boolean
  equipmentType: QuoteEquipmentType
  items: Array<QuoteItem>
  mileage?: number
  mode: QuoteMode
  notes?: string
  shipperGuideId: string
  shipperNotes?: string
  stops: Array<QuoteStop>
  accessorials?: Array<QuoteAccessorial>
}

export function isQuoteExpired({ bidsDeadline }: Quote): boolean {
  return isPast(bidsDeadline)
}

export function mapQuoteStopsToCoreStops({ stops }: Quote): Array<Stop> {
  return stops.map(s => ({
    city: s.city,
    state: s.state,
    zipCode: s.zipcode,
  }))
}
